import React from "react"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Button from "@material-ui/core/Button"
import Image from "./image"
import Hidden from "@material-ui/core/Hidden"

const Hero = () => {
  return (
    <Grid container spacing={3} style={{ minHeight: 500 }}>
      <Grid
        item={true}
        xs={12}
        sm={6}
        container
        direction="column"
        justify="center"
        alignItems="flex-start"
        style={{ paddingLeft: 40, paddingRight: 40 }}
      >
        <Typography
          variant="h4"
          component="h1"
          color="inherit"
          style={{ marginBottom: 20 }}
        >
          Small routines. Great habits.
        </Typography>

        <Typography variant="subtitle1" style={{ marginBottom: 30 }}>
          Make time for learning, practice, and play. Build a visual weekly plan
          with AI and share it with your family to help turn everyday routines
          into lasting habits.
        </Typography>
        <div>
          <Button
            variant="contained"
            color="primary"
            size="large"
            href="https://app.schoolcalendar.me"
            style={{ marginRight: 12, marginBottom: 12 }}
          >
            Create next week’s calendar
          </Button>
          <Button
            variant="outlined"
            color="primary"
            size="large"
            href="/use-cases/weekly-classroom-calendar/"
            style={{ marginBottom: 12 }}
          >
            Follow the classroom tutorial
          </Button>
        </div>
      </Grid>
      <Hidden xsDown>
        <Grid
          item={true}
          sm={6}
          container
          direction="column"
          justify="center"
          alignItems="flex-start"
          style={{ padding: 10 }}
        >
          <div style={{ width: "100%" }}>
            <Image alt="School calendar snapshot" filename="hero-image.jpg" />
          </div>
        </Grid>
      </Hidden>
    </Grid>
  )
}
export default Hero
